<div [hidden]="imageFile" class="dropzone-wrapper ">
    <div class="dropzone-desc">
        <i class="vsm-icon pe-7s-download"></i>
        <p>Choose an image file or drag it here.</p>
    </div>
    <input type="file" name="image" id="image" (change)="fileLoad($event)" class="dropzone"
           #imageFileEvent>
</div>

<div [hidden]="!imageFile" class="imageholder">
    <img src="{{imageFile}}" class="displayImage"/>
    <button type="button" class="btn-shadow btn btn-outline-success imageEdit">
        <fa-icon [icon]="editIcon" (click)="imageFileEvent.click()"></fa-icon>
    </button>
    <button type="button" class="btn-shadow btn btn-outline-danger imageDelete">
        <fa-icon [icon]="trashIcon"  (click)="removeImage()"></fa-icon>
    </button>
</div>
